export default __webpack_public_path__ + "static/media/no-profile.67b6df19.png";